import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetCommentMarkerSyncStatusMutationVariables = Types.Exact<{
  input: Types.SetCommentMarkerSyncStatusInput;
}>;


export type SetCommentMarkerSyncStatusMutation = { __typename?: 'Mutation', setCommentMarkerSyncStatus: { __typename?: 'CommentMarkerSyncStatus', assetId: string, documentId?: string | null, status: Types.MarkerSyncStatusState } };


export const SetCommentMarkerSyncStatus = /*#__PURE__*/ gql`
    mutation SetCommentMarkerSyncStatus($input: SetCommentMarkerSyncStatusInput!) {
  setCommentMarkerSyncStatus(input: $input) {
    assetId
    documentId
    status
  }
}
    ` as unknown as DocumentNode<SetCommentMarkerSyncStatusMutation, SetCommentMarkerSyncStatusMutationVariables>;

          

          export const useSetCommentMarkerSyncStatusMutation = (options?:MutationHookOptions<SetCommentMarkerSyncStatusMutation, SetCommentMarkerSyncStatusMutationVariables>) => useMutation(SetCommentMarkerSyncStatus, options);
          

          export type SetCommentMarkerSyncStatusMutationOptions = MutationHookOptions<SetCommentMarkerSyncStatusMutation, SetCommentMarkerSyncStatusMutationVariables>;

          

          export type SetCommentMarkerSyncStatusMutationResult = ReturnType<typeof useSetCommentMarkerSyncStatusMutation>[1];

          
